module.exports = __webpack_public_path__ + "static/media/1670889-slide-dsc-8771.672eb774.jpg";